import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";

import Breadcrumb from "../../components/Breadcrumb";
import FirstStep from "../../components/HotelsGroups/HotelsGroupCreate/FirstStep";

import { Steps } from "antd";
const { Step } = Steps;

class HotelsGroupCreate extends Component {
  state = {
    current: 0,
    create: true,
    select: null,
    selectData: null,
    selectHmgId: null,
    selectHotelsGroups: [],
    selectHotels: [],
  };

  async componentDidMount() {
    if (!this.props.api.hmgGetData) {
      await this.props.hmgGet();
    }
    if (!this.props.api.hotelsGroupsGetData) {
      await this.props.hotelsGroupsGet();
    }
    if (!this.props.api.hotelGetData) {
      await this.props.hotelGet();
    }
    if (!this.props.api.hmgMainGetData) {
      await this.props.hmgMainGet();
    }
  }

  formFirstStepSaveFormRef = (formRef) => {
    this.formFirstStepFormRef = formRef;
  };

  formSecondStepSaveFormRef = (formRef) => {
    this.formSecondStepFormRef = formRef;
  };

  customFormRest = () => {
    if (this.formFirstStepFormRef && this.formFirstStepFormRef.props) {
      this.formFirstStepFormRef.props.form.setFieldsValue({
        hotel_group_name_1: "",
        // hmg_name_1 : ""
      });
    }
  };

  formFirstStepSubmit = (e) => {
    e.preventDefault();
    const { form } = this.formFirstStepFormRef.props;
    // const { formTwo } = this.formTwoFormRef.props;
    form.validateFields(async (err, values) => {
      if (err) {
        return;
      }
      // console.log(values, "values");

      if (this.state.create) {
        if (await this.props.hotelsGroupCreate(values)) {
          // form.resetFields();
          await this.props.hotelsGroupsGet();
          form.resetFields();
          this.customFormRest();
        }
      } else {
        if (await this.props.hotelsGroupUpdate(values)) {
          // form.resetFields();
          await this.props.hotelsGroupsGet();
          form.resetFields();
          this.customFormRest();
          //   this.setState({ current: 0 });
        }
      }
    });
  };

  formSecondStepSubmit = (e) => {
    e.preventDefault();
    const { form } = this.formSecondStepFormRef.props;
    // const { formTwo } = this.formTwoFormRef.props;
    form.validateFields(async (err, values) => {
      if (err) {
        return;
      }
      console.log(values, "values");

      // if (this.state.create) {
      //   if (await this.props.hmgCreate(values)) {
      //     // form.resetFields();
      //     await this.props.hmgGet();
      //   }
      // } else {
      //   console.log("noooo");

      //   if (await this.props.hmgUpdate(values)) {
      //     // form.resetFields();
      //     await this.props.hmgGet();
      //     this.next();
      //   }
      // }
    });
  };

  autoCompleteOneChangeFunction = async (value) => {
    if (value === undefined) {
      value = "";
    }

    const result = this.props.api.hotelsGroupsGetData.data.find(
      (e) =>
        e.hotel_group_name.toUpperCase() === value.toUpperCase() &&
        e.hmg_id === this.state.selectHmgId
    );
    if (result) {
      await this.setState({ create: false, selectData: result });

      if (this.formFirstStepFormRef && this.formFirstStepFormRef.props) {
        let initialValue = null;
        if (this.state.selectData) {
          initialValue = this.state.selectData;
        }

        let hotel_ids = [];
        if (initialValue?.hotels) {
          hotel_ids = initialValue.hotels.map((d) => d._id);
        }

        this.formFirstStepFormRef.props.form.setFieldsValue({
          _id: initialValue && initialValue._id ? initialValue._id : null,
          hotel_group_name:
            initialValue && initialValue.hotel_group_name
              ? initialValue.hotel_group_name
              : null,
          hotels: hotel_ids,
        });

        // this.formSecondStepFormRef.props.form.setFieldsValue({

        //   corp_address:
        //     initialValue && initialValue.corp_address
        //       ? initialValue.corp_address
        //       : null
        // });
      }
    } else {
      this.setState({ create: true, selectData: null });
      // this.formFirstStepFormRef.props.form.resetFields();

      this.formFirstStepFormRef.props.form.setFieldsValue({
        hotel_group_name: value,
        hotels: [],
      });
    }
  };

  autoCompleteOneSelect = async (value, option) => {
    await this.autoCompleteOneChangeFunction(value);

    // await this.formOneSubmitFunction();
  };
  autoCompleteOneChange = (value, label) => {
    this.autoCompleteOneChangeFunction(value);
  };

  firstStepHmgMainIdOnChange = (value) => {
    this.formFirstStepFormRef.props.form.setFieldsValue({
      _id: null,
      hotel_group_name: "",
      hotel_group_name_1: "",
      hotels: [],
    });
    this.setState({
      selectHotels: [],
      selectData: null,
      create: true,
    });
  };

  hmgIdOneChange = (value, label) => {
    this.formFirstStepFormRef.props.form.setFieldsValue({
      _id: null,
      hotel_group_name: "",
      hotel_group_name_1: "",
      hotels: [],
    });

    this.setState({ create: true, selectHmgId: value });

    const result = this.props.api.hotelsGroupsGetData.data.filter(
      (e) => e.hmg_id === value
    );

    if (result) {
      this.setState({ selectHotelsGroups: result });
    }

    const hotelsResult = this.props.api.hotelGetData.data.filter(
      (e) => e.primary_hmg_id === value
    );
    if (hotelsResult) {
      this.setState({ selectHotels: hotelsResult });
    }
  };

  next = () => {
    const { form } = this.formFirstStepFormRef.props;
    // const { formTwo } = this.formTwoFormRef.props;
    form.validateFields(async (err, values) => {
      if (err) {
        return;
      }
      console.log(values, "values");
      const current = this.state.current + 1;
      this.setState({ current });
    });
  };

  prev = () => {
    const current = this.state.current - 1;
    this.setState({ current });
  };
  render() {
    const { current } = this.state;

    const steps = [
      {
        title: "GENERAL INFORMATION",
        content: "First-content",
      },
    ];

    return (
      <div>
        <div className="container_aa">
          <h3>Hotels Group Create and Update</h3>
          <Breadcrumb
            routes={[
              { path: "/", breadcrumbName: "Dashboard" },
              {
                path: "hotels-group-create",
                breadcrumbName: "Hotels Group Create and Update",
              },
            ]}
          />
        </div>

        <div className="container_ab">
          <div className="container_style_2">
            <div>
              <Steps current={current}>
                {steps.map((item) => (
                  <Step key={item.title} title={item.title} />
                ))}
              </Steps>

              <div style={{ marginBottom: 20 }}></div>

              <div className="steps-content">
                {this.props.api.hmgGetData && this.props.api.hmgMainGetData ? (
                  <FirstStep
                    wrappedComponentRef={this.formFirstStepSaveFormRef}
                    onSubmit={this.formFirstStepSubmit}
                    hmgGetData={this.props.api.hmgGetData.data}
                    hmgMainGetData={this.props.api.hmgMainGetData.data}
                    hmgIdOneChange={this.hmgIdOneChange}
                    firstStepHmgMainIdOnChange={this.firstStepHmgMainIdOnChange}
                    autoCompleteOneChange={this.autoCompleteOneChange}
                    autoCompleteOneSelect={this.autoCompleteOneSelect}
                    createStatus={this.state.create}
                    selectHotelsGroups={this.state.selectHotelsGroups}
                    selectHotels={this.state.selectHotels}
                    current={current}
                    next={this.next}
                    prev={this.prev}
                    steps={steps}
                    initialValue={this.state.selectData}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

const mapDispatchToProps = (dispatch) => ({
  hmgGet: () => dispatch(actions.hmgGet()),
  hmgMainGet: () => dispatch(actions.hmgMainGet()),
  hotelsGroupsGet: () => dispatch(actions.hotelsGroupsGet()),
  hotelGet: () => dispatch(actions.hotelGet()),

  hotelsGroupCreate: (data) => dispatch(actions.hotelsGroupCreate(data)),
  hotelsGroupUpdate: (data) => dispatch(actions.hotelsGroupUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HotelsGroupCreate);
